import { Injectable } from '@angular/core';
import { CompositeFilter } from '../filter.type';
import { LZString } from "./lz-string";

@Injectable({
    providedIn: 'root'
})
export class FilterCodec {

    encode(filter: CompositeFilter) {
        const stringifiedJsonFilter = JSON.stringify(filter);
        return LZString().compressToEncodedURIComponent(stringifiedJsonFilter);
    }

    decode(encoded: string): CompositeFilter | undefined {
        const asString = LZString().decompressFromEncodedURIComponent(encoded);

        if (asString === '') {
            return undefined;
        } else {
            return JSON.parse(asString);
        }
    }
}
